App.prototype.notificationSuccess = function (message) {
    new Noty({
        timeout: 2000,
        type: 'success',
        layout: 'topCenter',
        closeWith: ['click', 'button'],
        text: message,
    }).show();
}

App.prototype.notificationError = function (message) {
    new Noty({
        timeout: 2000,
        type: 'error',
        layout: 'topCenter',
        closeWith: ['click', 'button'],
        text: message,
    }).show();
}
